import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import {
  Handwriting,
  Initials,
  Ornaments,
  MachineWriting,
  Graphic,
  EngravingPhoto,
} from 'modules/cart/components/engraving'
import { EngraveTabs } from '_app/types/product'

enum TABS_ORDER {
  graw_masz_spec_2,
  graw_masz_spec_1,
  graw_masz_spec,
  graw_reczny,
  malowanie_1,
  malowanie_2,
}

export function useEngravingTabs() {
  const { t } = useTranslation('product')

  const engraveTabs = useMemo<EngraveTabs>(
    () => ({
      malowanie_2: {
        name: t('ORNAMENTS'),
        id: 'malowanie_2',
        component: Ornaments,
        img: '/images/product/drawer/engr_product.webp',
        order: TABS_ORDER.malowanie_2,
      },
      graw_reczny: {
        name: t('HAND_LETTERING'),
        id: 'graw_reczny',
        component: Handwriting,
        img: '/images/product/drawer/engr_product_heart.webp',
        order: TABS_ORDER.graw_reczny,
      },
      graw_masz_spec_1: {
        name: t('MACHINE_LETTERING'),
        id: 'graw_masz_spec_1',
        component: MachineWriting,
        img: '/images/product/drawer/engr_special_round.webp',
        order: TABS_ORDER.graw_masz_spec_1,
      },
      graw_masz_spec_2: {
        name: t('GRAPHICS'),
        id: 'graw_masz_spec_2',
        component: Graphic,
        img: '/images/product/drawer/engr_product_heart.webp',
        order: TABS_ORDER.graw_masz_spec_2,
      },
      malowanie_1: {
        name: t('INITIALS'),
        id: 'malowanie_1',
        component: Initials,
        img: '/images/product/drawer/engr_product_2.webp',
        order: TABS_ORDER.malowanie_1,
      },
      graw_masz_spec: {
        name: t('FROM_PHOTO'),
        id: 'graw_masz_spec',
        component: EngravingPhoto,
        img: '/images/product/drawer/engr_special_round.webp',
        order: TABS_ORDER.graw_masz_spec,
      },
    }),
    [t]
  )

  return engraveTabs
}
